module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "viewContainer"
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "付费分享推广",
      "name": "second"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeName == 'first'),
      expression: "activeName == 'first'"
    }],
    staticClass: "main_container"
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('h3', [_vm._v("充值信息：")]), _vm._v(" "), _c('el-form', [_c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "推广客户单价：",
      "label-width": "120px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "placeholder": "请输入",
      "disabled": ""
    },
    model: {
      value: (_vm.tgkhdj),
      callback: function($$v) {
        _vm.tgkhdj = $$v
      },
      expression: "tgkhdj"
    }
  }, [_c('i', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "slot": "suffix"
    },
    slot: "suffix"
  }, [_vm._v("元/条")])])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "推广条数：",
      "label-width": "120px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "placeholder": "请输入购买条数",
      "onkeyup": "this.value=this.value.replace(/\\D|^0/g,'')"
    },
    model: {
      value: (_vm.tgts),
      callback: function($$v) {
        _vm.tgts = $$v
      },
      expression: "tgts"
    }
  }, [_c('i', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "slot": "suffix"
    },
    slot: "suffix"
  }, [_vm._v("条")])])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "微信手续费6‰：",
      "label-width": "120px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "placeholder": "请输入",
      "disabled": ""
    },
    model: {
      value: (_vm.wxsxf),
      callback: function($$v) {
        _vm.wxsxf = $$v
      },
      expression: "wxsxf"
    }
  }, [_c('i', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "slot": "suffix"
    },
    slot: "suffix"
  }, [_vm._v("元")])])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "需充值金额：",
      "label-width": "120px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "placeholder": "请输入",
      "disabled": ""
    },
    model: {
      value: (_vm.xczje),
      callback: function($$v) {
        _vm.xczje = $$v
      },
      expression: "xczje"
    }
  }, [_c('i', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "slot": "suffix"
    },
    slot: "suffix"
  }, [_vm._v("元")])])], 1)], 1), _vm._v(" "), _c('ul', {
    staticClass: "zysmUl"
  }, [_c('b', [_vm._v("充值说明：")]), _vm._v(" "), _c('li', [_vm._v("1. 未使用金额可随时退款；")]), _vm._v(" "), _c('li', [_vm._v("2. 充值千分之6的手续费是微信收取。")])]), _vm._v(" "), _c('div', {
    staticClass: "upBtn"
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.chongzhi(1)
      }
    }
  }, [_vm._v("充值")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  })], 1), _vm._v(" "), _c('el-divider'), _vm._v(" "), _c('div', {
    staticClass: "table_inner_container"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('b', [_vm._v("充值记录：")]), _c('span', {
    staticStyle: {
      "color": "#F56C6C",
      "margin-right": "20px"
    }
  }, [_vm._v("本店累计充值 " + _vm._s(_vm.showRechargeCount) + "次，累计金额：" + _vm._s(_vm.showAmount) + "元")]), _c('span', {
    staticStyle: {
      "color": "#409EFF"
    }
  }, [_vm._v("当前可付费推广客户数余额为：" + _vm._s(_vm.showLeave) + " 条")])]), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.rechargeRecordList,
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "num",
      "label": "序号",
      "align": "center",
      "width": "60px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "充值时间",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.rechargTime))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "客户单价（元）",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.price))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "推广条数",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.quantity))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "充值金额（含手续费/元）",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.recharge))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "已付费推广条数",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.paidQuantity))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "剩余可用条数",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.leave))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "备注",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.remarks))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "fixed": "right",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.refund == 0 && scope.row.leave > 0),
            expression: "scope.row.refund == 0 && scope.row.leave>0"
          }],
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.tuikuan(scope.row.id)
            }
          }
        }, [_vm._v("退款")]), _vm._v(" "), _c('span', {
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.seeOrder(scope.row.id, 1)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-view"
        }), _vm._v("查看")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "order_toolbar_footer",
    staticStyle: {
      "margin-top": "15px",
      "float": "right"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.pageIndex,
      "page-size": 10,
      "total": _vm.czjlTotal
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeName == 'second'),
      expression: "activeName == 'second'"
    }],
    staticClass: "main_container"
  }, [(_vm.isshowfffxtg) ? _c('div', [_c('section', {
    staticClass: "model_section"
  }, [_c('p', {
    staticClass: "model_top_title"
  }, [_vm._v("推广记录：")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_vm._v("本店已分享推广 " + _vm._s(_vm.fffxtgTotal) + " 次")]), _c('span', {
    staticStyle: {
      "color": "#F56C6C"
    }
  }, [_vm._v("【未使用金额推广到期后自动退款】")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right",
      "margin": "6px 10px 0 0"
    },
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.seepeizhi('')
      }
    }
  }, [_vm._v("新增推广")])], 1), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.fffxtgList,
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "num",
      "label": "序号",
      "align": "center",
      "width": "60px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.$index + 1))])]
      }
    }], null, false, 4178052834)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "分享内容",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.taskname))]
      }
    }], null, false, 4285705783)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "分享规则",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.tasktypename))]
      }
    }], null, false, 4288234415)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "有效期限",
      "align": "center",
      "width": "180px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.begindate) + "-" + _vm._s(scope.row.enddate))]
      }
    }], null, false, 2421660405)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "金额（元）",
      "align": "center",
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.bonus))]
      }
    }], null, false, 1874902360)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "份数",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.consume) + "/" + _vm._s(scope.row.totalcount))]
      }
    }], null, false, 2287133810)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "金额（元）",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.totalprice))]
      }
    }], null, false, 959835826)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.status == 1),
            expression: "scope.row.status==1"
          }]
        }, [_vm._v("待开始")]), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.status == 2),
            expression: "scope.row.status==2"
          }]
        }, [_vm._v("已退款")]), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.status == 3),
            expression: "scope.row.status==3"
          }]
        }, [_vm._v("进行中")]), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.status == 4),
            expression: "scope.row.status==4"
          }]
        }, [_vm._v("已结束")])]
      }
    }], null, false, 1070623702)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "分享文案",
      "align": "center",
      "width": "160px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList",
          attrs: {
            "title": scope.row.sharecopy
          }
        }, [_vm._v(_vm._s(scope.row.sharecopy))])]
      }
    }], null, false, 681772292)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "备注",
      "align": "center",
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.remark))]
      }
    }], null, false, 3468652191)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "fixed": "right",
      "align": "center",
      "width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.seepeizhi(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-view"
        }), _vm._v("查看配置")]), _vm._v(" "), _c('span', {
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.seeOrder(scope.row.brrid, 2)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-view"
        }), _vm._v("查看记录")]), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.refund == 0 && scope.row.leave > 0),
            expression: "scope.row.refund == 0 && scope.row.leave>0"
          }],
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.tuikuan(scope.row.id)
            }
          }
        }, [_vm._v("退款")])]
      }
    }], null, false, 2113598215)
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "margin": "10px 0",
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.fffxtgIndex,
      "page-size": 10,
      "total": _vm.fffxtgTotal
    },
    on: {
      "current-change": _vm.handlefffxtg
    }
  })], 1)]) : _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "element-loading-text": "分享推广配置中...",
      "element-loading-spinner": "el-icon-loading"
    }
  }, [_c('el-row', {
    staticStyle: {
      "margin": "0 0 0 10px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('h3', [_vm._v("分享赚钱配置")]), _vm._v(" "), _c('el-form', [_c('el-form-item', {
    staticStyle: {
      "width": "80%",
      "margin-bottom": "5px"
    },
    attrs: {
      "label": "有效期限：",
      "label-width": "100px"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "80%",
      "background": "#fff",
      "border": "1px solid #eee"
    },
    attrs: {
      "type": "daterange",
      "title": _vm.value6,
      "disabled": _vm.seefffxtg,
      "value-format": "yyyy-MM-dd",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "picker-options": _vm.pickerOptions
    },
    on: {
      "change": _vm.changetime
    },
    model: {
      value: (_vm.value6),
      callback: function($$v) {
        _vm.value6 = $$v
      },
      expression: "value6"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "80%",
      "margin-bottom": "5px"
    },
    attrs: {
      "label": "分享规则：",
      "label-width": "100px"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "disabled": _vm.seefffxtg
    },
    model: {
      value: (_vm.fxdpyq),
      callback: function($$v) {
        _vm.fxdpyq = $$v
      },
      expression: "fxdpyq"
    }
  }, _vm._l((_vm.tasktyps), function(item) {
    return _c('el-radio', {
      key: item.bttid,
      staticStyle: {
        "margin-right": "15px"
      },
      attrs: {
        "label": item.bttid
      }
    }, [_vm._v(_vm._s(item.tasktypename))])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "分享文案：",
      "label-width": "100px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "type": "textarea",
      "rows": 3,
      "placeholder": "请输入分享文案内容",
      "maxlength": "100",
      "show-word-limit": "",
      "disabled": _vm.seefffxtg
    },
    model: {
      value: (_vm.recharge.remark),
      callback: function($$v) {
        _vm.$set(_vm.recharge, "remark", $$v)
      },
      expression: "recharge.remark"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "单份奖励：",
      "label-width": "100px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "placeholder": "请输入",
      "maxlength": "6",
      "onkeyup": "this.value=this.value.replace(/\\D|^0/g,'')",
      "disabled": _vm.seefffxtg
    },
    model: {
      value: (_vm.rewardTwo),
      callback: function($$v) {
        _vm.rewardTwo = $$v
      },
      expression: "rewardTwo"
    }
  }, [_c('i', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "slot": "suffix"
    },
    slot: "suffix"
  }, [_vm._v("元")])])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "奖励份数：",
      "label-width": "100px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "placeholder": "请输入奖励份数",
      "onkeyup": "this.value=this.value.replace(/\\D|^0/g,'')",
      "disabled": _vm.seefffxtg,
      "maxlength": "6"
    },
    model: {
      value: (_vm.recharge.totalcount),
      callback: function($$v) {
        _vm.$set(_vm.recharge, "totalcount", $$v)
      },
      expression: "recharge.totalcount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "分享要求：",
      "label-width": "100px"
    }
  }, [(_vm.tasktyps.length > 0) ? _c('div', _vm._l((_vm.tasktyps.find(function (t) { return t.bttid == _vm.fxdpyq; }).descriptions), function(desc, index) {
    return _c('ul', {
      key: index
    }, [(desc.taskdesc.startsWith('【朋友圈】') || desc.taskdesc.startsWith('【微信群】')) ? _c('li', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v("\r\n                    " + _vm._s(desc.taskdesc) + "\r\n                  ")]) : _c('li', {
      staticStyle: {
        "color": "#999",
        "line-height": "30px"
      }
    }, [_vm._v("\r\n                    " + _vm._s(desc.taskdesc) + "\r\n                  ")])])
  }), 0) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "80%",
      "margin-left": "15px"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#999"
    }
  }, [_c('b', {
    staticStyle: {
      "font-size": "20px",
      "color": "#333"
    }
  }, [_vm._v("推广费：" + _vm._s(Math.ceil(_vm.recharge.totalprice * 100) / 100) + "元")])])])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('h3', [_vm._v("付费推广目的：")]), _vm._v(" "), _c('ul', [_vm._l((_vm.ckfxjxj), function(item, index) {
    return _c('li', {
      key: index,
      staticStyle: {
        "line-height": "32px"
      }
    }, [_vm._v(_vm._s(item.name))])
  }), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_vm._v("4.示例截图")]), _vm._v(" "), (_vm.tasktyps.length > 0) ? _c('ul', {
    staticClass: "videoandpic"
  }, _vm._l((_vm.tasktyps.find(function (i) { return i.bttid == _vm.fxdpyq; }).examples), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.mediatype == 2),
        expression: "item.mediatype == 2"
      }],
      staticClass: "el-icon-video-play mengceng"
    }), _vm._v(" "), _c('el-image', {
      staticStyle: {
        "width": "100px",
        "height": "100px"
      },
      attrs: {
        "src": _vm.baseOssUrl + item.mediapath,
        "fit": "cover",
        "preview-src-list": [_vm.baseOssUrl + item.mediapath]
      },
      on: {
        "click": _vm.handleClickItem
      }
    })], 1)
  }), 0) : _vm._e()], 2), _vm._v(" "), _c('h3', {
    staticStyle: {
      "line-height": "0",
      "margin-bottom": "20px"
    }
  }, [_vm._v("创客范围")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("按从事行业：")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "800px"
    }
  }, [_c('el-checkbox-group', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    on: {
      "change": _vm.handleCheckedCities
    },
    model: {
      value: (_vm.formmenuOne),
      callback: function($$v) {
        _vm.formmenuOne = $$v
      },
      expression: "formmenuOne"
    }
  }, _vm._l((_vm.industry), function(item) {
    return _c('el-checkbox', {
      key: item.id,
      attrs: {
        "label": item.id
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formmenuOne.find(function (i) { return i == 2; })),
      expression: "formmenuOne.find(i=>i==2)"
    }],
    staticStyle: {
      "height": "200px",
      "display": "flex"
    }
  }, [_c('span', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("按建材品类：")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-y": "scroll",
      "display": "grid",
      "padding": "0 10px 0 0"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "indeterminate": _vm.isIndeterminateTwo
    },
    on: {
      "change": function($event) {
        return _vm.handleCheckAllChange(_vm.checkAlltwo, 2)
      }
    },
    model: {
      value: (_vm.checkAlltwo),
      callback: function($$v) {
        _vm.checkAlltwo = $$v
      },
      expression: "checkAlltwo"
    }
  }, [_vm._v("\r\n                全部\r\n              ")]), _vm._v(" "), _c('el-tree', {
    ref: "tree",
    staticClass: "cktree",
    staticStyle: {
      "margin-top": "5px"
    },
    attrs: {
      "show-checkbox": "",
      "data": _vm.category,
      "node-key": "id",
      "highlight-current": "",
      "props": _vm.defaultProps,
      "default-checked-keys": _vm.formmenuTwo
    }
  })], 1)])])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "margin": "20px auto",
      "text-align": "center"
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.isshowfffxtg = true
      }
    }
  }, [_vm._v(_vm._s(_vm.seefffxtg ? '返回' : '取消'))]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.seefffxtg),
      expression: "!seefffxtg"
    }],
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.chongzhi(2)
      }
    }
  }, [_vm._v("确定")])], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "请使用微信扫码支付",
      "visible": _vm.qsywxsmzf,
      "width": "20%",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.qsywxsmzf = $event
      },
      "closed": _vm.clearWxzf
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [(_vm.leixing == 1) ? _c('p', {
    staticStyle: {
      "font-size": "26px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.xczje) + "  元")]) : _c('p', {
    staticStyle: {
      "font-size": "26px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(Math.ceil(_vm.recharge.totalprice * 100) / 100) + "  元")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "src": _vm.wxSmzfImg
    }
  })])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "退款提示",
      "visible": _vm.refund,
      "width": "25%",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.refund = $event
      },
      "closed": _vm.clearTk
    }
  }, [_c('p', [_vm._v("确定进行退款操作吗？如确定申请退款，退款申请成功，余额将返回原支付微信账户，请注意查收。")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.refund = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.handleTk()
      }
    }
  }, [_vm._v("确定")])], 1)]), _vm._v(" "), _c('el-drawer', {
    attrs: {
      "title": "已付费推广客户明细",
      "custom-class": "registrationRecord",
      "visible": _vm.visibleSeeLlmx,
      "size": "48%"
    },
    on: {
      "update:visible": function($event) {
        _vm.visibleSeeLlmx = $event
      }
    }
  }, [_c('el-table', {
    staticStyle: {
      "margin": "0px"
    },
    attrs: {
      "data": _vm.seeLlmxList
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "align": "center",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), (_vm.czxxType == 1) ? [_c('el-table-column', {
    key: "1",
    attrs: {
      "property": "mobile",
      "label": "客户手机号",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    key: "2",
    attrs: {
      "property": "lastTime",
      "label": "最近活跃时间",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    key: "3",
    attrs: {
      "property": "source",
      "label": "来源渠道",
      "align": "center"
    }
  })] : [_c('el-table-column', {
    key: "4",
    attrs: {
      "property": "phone",
      "label": "创客",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    key: "5",
    attrs: {
      "property": "createtime",
      "label": "奖励发放时间",
      "align": "center"
    }
  })]], 2), _vm._v(" "), _c('el-col', {
    staticClass: "order_toolbar_footer",
    staticStyle: {
      "margin-top": "15px",
      "float": "right"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right",
      "margin-top": "10px"
    },
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.pageIndexLlmx,
      "page-size": 10,
      "total": _vm.totalRowsCountLlmx
    },
    on: {
      "current-change": _vm.handleLlmx
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "图片查看",
      "visible": _vm.largeImage,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.largeImage = $event
      },
      "closed": _vm.clearImg
    }
  }, [_c('div', {
    staticClass: "imgDialog"
  }, [_c('img', {
    attrs: {
      "src": _vm.showImageUrl
    }
  })])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "视频播放",
      "visible": _vm.videoVisible,
      "center": "",
      "width": "35%"
    },
    on: {
      "update:visible": function($event) {
        _vm.videoVisible = $event
      },
      "close": _vm.closeDialog
    }
  }, [_c('video-player', {
    ref: "videoPlayer",
    staticClass: "video-player vjs-custom-skin",
    attrs: {
      "playsinline": true,
      "options": _vm.playerOptions
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "确认提示",
      "visible": _vm.fufeidialog,
      "width": "30%",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.fufeidialog = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "10px 0 20px 0",
      "font-size": "16px"
    }
  }, [_vm._v("需支付以下数额推广费，确定支付并创建本次推广吗?")]), _vm._v(" "), _c('b', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("-" + _vm._s(_vm.zysj) + " 元")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "20px"
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.fufeidialog = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.qdfufeu()
      }
    }
  }, [_vm._v("确定")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "充值提示",
      "visible": _vm.chongzhidialog,
      "width": "25%",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.chongzhidialog = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('p', {
    staticStyle: {
      "margin": "10px 0 30px 0",
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.chognzhitishi))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.chongzhidialog = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.quchongzhi()
      }
    }
  }, [_vm._v("去充值")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "操作完成",
      "visible": _vm.czwcDialog,
      "width": "25%",
      "center": "",
      "showClose": false,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.czwcDialog = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('i', {
    staticClass: "el-icon-circle-check",
    staticStyle: {
      "font-size": "100px",
      "color": "#67C23A"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "18px 0"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "20px"
    }
  }, [_vm._v("分享推广配置成功")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('el-button', {
    staticStyle: {
      "padding": "0 3em",
      "line-height": "3.2em"
    },
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.qdczcg()
      }
    }
  }, [_vm._v("确定")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "center": true,
      "title": "请选择店铺",
      "visible": _vm.dialogVisibleadd,
      "width": "25%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisibleadd = $event
      }
    }
  }, [_c('el-form', {
    staticClass: "findform"
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "label": "店铺名称："
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择店铺"
    },
    on: {
      "change": _vm.handleChangedptype
    },
    model: {
      value: (_vm.bbid),
      callback: function($$v) {
        _vm.bbid = $$v
      },
      expression: "bbid"
    }
  }, _vm._l((_vm.options1), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.gonext()
      }
    }
  }, [_vm._v("确定")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-bc6c1762!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/operationManagement/paidPromotion.vue
// module id = 1746
// module chunks = 3